<template>
  <div class="purple-round-input input-wrapper" :class="{ error }">
    <input
      type="number"
      inputmode="numeric"
      class="w-full h-12 outline-none"
      min="1900"
      :max="maxYear"
      step="1"
      v-model="data"
      @input="emitInput"
      @blur="emitInput"
      required
      :placeholder="$t('profile.birthyear')"
    />
  </div>
</template>

<script>
export default {
  name: 'BirthYear',
  props: {
    error: Boolean,
    value: [Number, String],
  },
  data: vm => ({
    data: vm.value,
  }),
  methods: {
    emitInput($event) {
      const { value } = $event.target;
      const valueInt = parseInt(value, 10);
      if (value.length > 4) {
        this.data = this.value;
      } else if (valueInt > this.maxYear) {
        this.data = this.maxYear;
      }
      this.$emit('update:error', this.data < this.minYear);
      this.$emit('input', this.data);
    },
  },
  computed: {
    minYear() {
      return 1900;
    },
    maxYear() {
      return parseInt(new Date().getFullYear(), 10);
    },
  },
  watch: {
    value(nv, ov) {
      if (!ov && nv) {
        this.data = nv;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.input-wrapper {
  @apply pl-6 pr-2;
  &.error {
    border-color: red;
  }
}
</style>
